import React from 'react'
import ListingsSvg from 'images/modules/Manage/i-listings.svg?raw'

export { default as ListingsUrl } from 'images/modules/Manage/i-listings.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ListingsSvg}} />
)
